import { traderStatuses } from '../constants';
import { type TraderStatus } from '../model';

export const formatTrader = {
    status: (status?: TraderStatus) => {
        if (!status) {
            return '';
        }

        const { label } =
            traderStatuses.find((p) => {
                return p.value === status;
            }) ?? {};

        return label;
    },
} as const;
